<div class="footer-wrapper">
  <div>
    <label>Contact</label>
    <a href="mailto:RetirementSavings@ama.ab.ca" target="_blank">RetirementSavings@ama.ab.ca</a>
  </div>
  <div>
    <a (click)="openTermsAndConditionsDialog()"><u>Terms & Conditions</u></a>
  </div>
</div>
